import { useQuery } from '@tanstack/react-query'
import { listIndeedFlexLongTermAssignmentPreview } from 'api/admin/indeedFlex/listIndeedFlexLongTermAssignmentPreview'
import { indeedFlexKeys } from './keys'

type UseIndeedFlexLongTermAssignmentPreviewQueryData = Awaited<
  ReturnType<typeof listIndeedFlexLongTermAssignmentPreview>
>

export const useIndeedFlexLongTermAssignmentPreviewQuery = ({
  ifClientId,
  ifJobId,
  enabled = true,
}: {
  ifClientId: number
  ifJobId: number
  enabled?: boolean
}) => {
  return useQuery<UseIndeedFlexLongTermAssignmentPreviewQueryData>({
    queryKey: indeedFlexKeys.longTermAssignmentPreview({ ifClientId, ifJobId }),
    queryFn: () =>
      listIndeedFlexLongTermAssignmentPreview({ ifClientId, ifJobId }),
    enabled,
  })
}
